import { MONTHS, RGBA_COLORS } from "../../../constants";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

const MAX_RANGE = 100;

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler);

const removeInvalidData = (arr) => {
  return arr.map((val) => (val > MAX_RANGE ? MAX_RANGE : val));
};

const Graph = ({ chartData }) => {
  const { GRID, LINE, DEFAULT } = RGBA_COLORS;
  let dataSetsForChart = [];
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          stepSize: 20,
        },
        min: 0,
        max: 100,
        border: {
          dash: [2, 2],
        },
        grid: {
          color: GRID,
        },
      },
    },
  };
  chartData.forEach((points, idx) =>
    dataSetsForChart.push({
      lineTension: 0.4,
      data: removeInvalidData(points.data),
      fill: true,
      backgroundColor: idx < LINE.length ? LINE[idx].bgColor : DEFAULT.bgColor,
      borderColor: idx < LINE.length ? LINE[idx].brColor : DEFAULT.brColor,
      pointRadius: 0,
    })
  );

  const data = {
    labels: MONTHS,
    datasets: dataSetsForChart,
  };

  return <Line options={options} data={data} />;
};

export default Graph;
